import { SignupFormData } from 'modules/auth/hooks/useSignupForm'
import { useFormContext } from 'react-hook-form'
import { CaptchaWidget } from '../CaptchaWidget/CaptchaWidget'

export const SignupFormCaptcha = () => {
  const { setValue } = useFormContext<SignupFormData>()

  const solvedHandler = (solution: string) => {
    setValue('captchaToken', solution)
  }

  const errorHandler = () => {
    setValue('captchaToken', null)
  }

  const resetHandler = () => {
    setValue('captchaToken', null)
  }

  return (
    <div className="flex justify-center">
      <CaptchaWidget
        solvedHandler={solvedHandler}
        errorHandler={errorHandler}
        resetHandler={resetHandler}
      />
    </div>
  )
}
